import api from 'services/api'
import {GET_MODULES, GET_USER_PERMISSIONS, UPDATE_USER_PERMISSIONS} from '../endpoints'

export const getModulesList = async () => await api.get(GET_MODULES)
export const getUserPermissions = async (body) => await api.post(GET_USER_PERMISSIONS, body)
export const updateUserPermissions = async (body) => await api.post(UPDATE_USER_PERMISSIONS, body)
